import { useEffect, useState } from 'react';

import * as api from '@/features/backlog/api';
import * as searchApi from '@/features/search/api';

// Session-level cache so the two autocomplete vocabularies load once, not per input mount / keystroke.
let labelsCache: string[] | null = null;
let statusLabelsCache: string[] | null = null;

/**
 * Loads the two SparkQL autocomplete vocabularies — item labels and (cross-board) status labels — once
 * per session and returns them, seeded synchronously from the module cache so a remount is instant.
 * Shared by the global search and the on-canvas search-results picker so they suggest the same values.
 */
export function useSearchVocab(): { labels: string[]; statusLabels: string[] } {
  const [labels, setLabels] = useState<string[]>(labelsCache ?? []);
  const [statusLabels, setStatusLabels] = useState<string[]>(statusLabelsCache ?? []);

  useEffect(() => {
    if (!labelsCache) api.listLabels().then((l) => { labelsCache = l; setLabels(l); }).catch(() => undefined);
    else if (labels.length === 0) setLabels(labelsCache);
    if (!statusLabelsCache) searchApi.statusLabels().then((l) => { statusLabelsCache = l; setStatusLabels(l); }).catch(() => undefined);
    else if (statusLabels.length === 0) setStatusLabels(statusLabelsCache);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { labels, statusLabels };
}
